<div [class.input-group]="prefix || suffix">
  @if (prefix) {
  <span class="input-group-text">{{ prefix }}</span>
  }

  <ng-content></ng-content>

  @if (suffix) {
  <span class="input-group-text">{{ suffix }}</span>
  }
</div>
